import React from 'react';
import {useIntl} from 'react-intl';
import DataTable from '../../components/dataTable';
import useStore from '../../hooks/use-store';
import {canSeeAuditFields} from '../../helpers/auth';

const DriverTable = (props) => {
  const intl = useIntl();
  const {store} = useStore();
  const showAuditFields = canSeeAuditFields(store.auth.profile);
  const {
    driverForm,
    removeRegister,
    attributes,
    list,
    loading,
  } = props;

  return (
    <DataTable
      add={driverForm}
      edit={driverForm}
      remove={removeRegister}
      list={list}
      loading={loading}
      attributes={attributes}
      keyField={'id'}
      confirmText={intl.formatMessage({id: 'driverRemoveConfirm'})}
      headers={[
        {title: 'sharedName', field: 'name', dataSort: true},
        {title: 'deviceIdentifier', field: 'uniqueId', dataSort: true},
        ...(showAuditFields ? [
          {title: 'sharedCreatedBy', field: 'creatorName', dataSort: true},
          {title: 'sharedCreatorEmail', field: 'creatorEmail', dataSort: true},
          {title: 'sharedCreatedAt', field: 'createdAtFormatted', dataSort: true},
          {title: 'sharedUpdatedAt', field: 'updatedAtFormatted', dataSort: true},
        ] : []),
      ]}
    />
  );
};

export default DriverTable;
